import request from './request'

export interface SendUpdateUserMobileCodeParams {
  id: number
  phone_code: string
  phone: string
}

export interface UpdateUserMobileParams {
  id: number
  phone_code: string
  phone: string
  sms_code: string
}

export interface UpdateUserMobileResponse {
  code: number
  msg: string
  data?: unknown
}

/** POST `/api/admin/user/send-update-mobile-code` */
export async function sendUpdateUserMobileCode(
  data: SendUpdateUserMobileCodeParams,
): Promise<UpdateUserMobileResponse> {
  return request.post<UpdateUserMobileResponse>('/api/admin/user/send-update-mobile-code', data)
}

/** POST `/api/admin/user/update-mobile` */
export async function updateUserMobile(
  data: UpdateUserMobileParams,
): Promise<UpdateUserMobileResponse> {
  return request.post<UpdateUserMobileResponse>('/api/admin/user/update-mobile', data)
}
